function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppArrowQuite = function SvgIcLogicGAppArrowQuite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10300",
    transform: "translate(-18.627 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_tart_close",
    transform: "translate(18.627 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_10245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_20730",
    d: "M0 0h30v30H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10744",
    d: "M37 15.4h-8.8l1.9-2c.4-.4.4-1 0-1.4s-1-.4-1.3 0l-3.6 3.8c-.4.4-.4 1 0 1.4l3.6 3.8c.4.4 1 .4 1.3 0 .4-.4.4-1 0-1.4l-1.9-2H37c2.2.1 3.8 2 3.7 4.1-.1 2-1.7 3.5-3.7 3.7h-9.1c-.6 0-1 .5-1 1.1s.5 1 1 1H37c3.3-.1 5.9-2.8 5.8-6 .1-3.3-2.5-6-5.8-6.1",
    style: {
      fill: "#5166c7"
    }
  })));
};
export default SvgIcLogicGAppArrowQuite;